var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hot-item"},[_vm._v("\n  "+_vm._s(_vm.item)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }